import { ApiClient } from '@webapp/core/services/ApiClient'
import { V1UserRepository } from '@webapp/platform/iam/data-access/repositories/V1UserRepository/V1UserRepository'

export const v1UserRepository = new V1UserRepository({
  httpClient: ApiClient,
})
